import { render, staticRenderFns } from "./News-detail.vue?vue&type=template&id=3b0fd375&scoped=true&"
import script from "./News-detail.vue?vue&type=script&lang=js&"
export * from "./News-detail.vue?vue&type=script&lang=js&"
import style0 from "./News-detail.vue?vue&type=style&index=0&id=3b0fd375&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0fd375",
  null
  
)

export default component.exports